







































































import { Component, Mixins } from 'vue-property-decorator';
import LocaleSelect from '@/components/LocaleSelect.vue';
import { Getter } from 'vuex-class';
import { LelyApp, LelyAuth } from '@hn-work/frontend-vue-shared';
import FormatsDate from '@/components/mixins/FormatsDate';
import { format } from 'date-fns';
import { knowledgeBaseUrl, NEW_APP_ALARMS_HOME, newAppUrl } from '@/core/newAppUrl';

@Component({
    methods: { format },
    components: {
        LocaleSelect,
    },
})
export default class NavigationTop extends Mixins(FormatsDate) {
    @Getter('isInternalUser')
    isInternalUser!: boolean;

    @Getter('isDeveloper')
    isDeveloper!: boolean;

    get loginPage() {
        return this.$route.meta?.layout === 'LoginLayout';
    }

    // Alarms moved to the new Alarm Center, so the logo — this app's "home" —
    // leads there rather than to the old open-runs page. Before signing in there
    // is no token to hand over, so it stays local and login does the handover.
    get homeUrl(): string {
        return LelyAuth.isAuthenticated() ? newAppUrl(NEW_APP_ALARMS_HOME) : '/';
    }

    // The knowledge base moved to its own app.
    get knowledgeBaseUrl(): string {
        return knowledgeBaseUrl();
    }

    get app(): LelyApp {
        return LelyApp.ALARMCENTER;
    }

    get alarmerStatus(): { updated_at: string; alive: boolean } | null {
        return this.$store.state.alarmerStatus;
    }

    logout() {
        this.$store.dispatch('stopSyncInterval');
        LelyAuth.logout();

        this.$router.push({ name: 'login' });
    }
}

